import { pickThemeColor, pickThemeFontStyles } from '@/theme';
import { Link } from '@/ui';
import styled from 'styled-components';

export const StyledLink = styled(Link)<{
  $withName?: boolean;
}>`
  padding: 0.5rem 1rem;
  background-color: ${pickThemeColor('DARK_PURPLE')};
  color: ${pickThemeColor('WHITE')};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  ${({ $withName }) => ($withName ? 'justify-content: flex-start;' : 'justify-content: center;')}

  .ant-image {
    height: 100%;
    display: flex;
    justify-content: center;

    .ant-image-img {
      object-fit: cover;
      height: 100%;
    }
  }

  &:hover {
    text-decoration: underline;
    color: ${pickThemeColor('WHITE')};
  }
`;

export const StyledName = styled.span`
  ${pickThemeFontStyles('16', '26')};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
